import { Plugin } from "chart.js";
import { formatDateTimeToString } from "../utils/formatDateTimeToString";

export const useXAxisDatePlugin = (): Plugin => {
	const chartPlugin: Plugin<"line"> = {
		id: "xAxisDatePlugin",
		afterBuildTicks(chart) {
			const oldTicks = chart.scales.x.ticks;

			const newTicks = [];
			newTicks.push(oldTicks[0]);

			for (let i = 1; i < oldTicks.length; i++) {
				const current = new Date(oldTicks[i].value);
				const previous = new Date(oldTicks[i - 1].value);

				const time = formatDateTimeToString(current).formattedTime;
				const date = formatDateTimeToString(current).formattedDate;

				let newLabel;
				let newMajor;

				if (current.getDate() !== previous.getDate()) {
					newLabel = [time, date];
					newMajor = true;
				} else {
					newLabel = time;
					newMajor = false;
				}

				newTicks.push({
					value: oldTicks[i].value,
					major: oldTicks[i].major,
					label: newLabel,
				});
			}
			chart.scales.x.ticks = newTicks;
		},
	};

	return chartPlugin;
};
